import React, { Component } from "react";
import {
  message,
  PageHeader,
  Col,
  Row,
  Spin,
  Select,
  Tabs,
  Checkbox,
  // Switch
} from "antd";
import { TimePicker } from "antd";

import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  ButtonItem,
  InputItem,
  SelectItem,
  InputNumberItem,
  ErrorItem,
  HeaderItem,
  BoxItem,

} from "../../../../Components/Items";
import DatePickerItem from "../../../../Components/DatePickerItem";
import TextAreaItem from "../../../../Components/TextAreaItem";
import moment from "moment";
import {
  opcionesBaseOriente,
  opcionesEstudioIdaVuelta,
  opcionesMercado,
  opcionesOrigen,
  opcionesTerapiaIntensiva,
  opcionesTipoDisOxigeno
} from "../../../../Components/OpcionesFormularioAmbulancia";


const { Option } = Select;
const { TabPane } = Tabs;


class LlenarFormulario extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pacientes: [],
    pacientesData: {},
    operadores: [],
  };

  atras() {
    this.props.history.goBack();
  }

  componentDidMount() {
    this.consultarTodo();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await this.consultarPacientes();
    await this.consultarEmpleados();
    this.setState({ loading: false });
  }


  //Función para consultar los pacientes para la opcion de elegir paciente
  async consultarPacientes() {

    await axios
      .post(
        "pacientes/selectPacientes",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          const pacientesRaw = res.data.pacientes;
          //Crea las opciones con los datos de los pacientes 
          const pacientesOptions = pacientesRaw.map((paciente) => (
            <Option key={paciente._id} value={paciente._id}>
              {paciente.nombre}
            </Option>
          ));

          const pacientesData = {};
          pacientesRaw.forEach((paciente) => {
            pacientesData[paciente._id] = {
              genero: paciente.genero || paciente.sexo,
              fechaNacimiento: paciente.fechaNacimiento,
            };
          });

          this.setState({ pacientes: pacientesOptions, pacientesData });
        }
      })
      .catch((err) => {
        console.error("Error al consultar pacientes", err);
        message.error("Error al cargar pacientes");
      });
  }


  // Función para consultar empleados y meterlos a las opciones de select
  async consultarEmpleados() {
    await axios.post(
      "empleados/selectEmpleados",
      { empresaId: this.props.empresaId },
      { headers: this.props.headersToken }
    )
      .then((res) => {
        if (res.data && Array.isArray(res.data)) {
          const empleadosOptions = res.data.map((empleado) => (
            <Option key={empleado._id} value={empleado._id}>
              {empleado.nombre}
            </Option>
          ));

          this.setState({ operadores: empleadosOptions });
        } else {
          message.warning("No se encontraron empleados activos");
        }
      })
      .catch((err) => {
        console.error("Error al consultar empleados", err);
        message.error("Error al cargar empleados");
      })
      ;

  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.actualizarCamposTiempo();
    this.setState({ loading: true });
    // Calcular tiempos si es necesario aquí, usando Date.parse o moment
    axios
      .post(
        "/formularioAmbulancia/llenarFormulario",
        { ...values, empresaId: this.props.empresaId, usuarioId: this.props.usuarioId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success) {
          message.success("Formulario guardado correctamente");
          this.formRef.current.resetFields();
          this.atras();
        } else {
          message.error("Error al guardar el formulario");
        }
      });
  }
  //Función para setear los otros campos que se auto rellenan con la información del paciente seleccionado
  handleSeleccionPaciente = (selected) => {
    const pacienteId = selected.value;
    const paciente = this.state.pacientesData[pacienteId];
    if (!paciente) return;

    const genero = paciente.genero || 3;
    const edad = this.calcularEdad(paciente.fechaNacimiento);

    this.formRef.current.setFieldsValue({
      genero,
      edad,
      paciente: selected,
    });
  };

  //Función para actualizar los campos de tiempo que son dependientes a otros 

  actualizarCamposTiempo = () => {
    const formValues = this.formRef.current.getFieldsValue();

    const {
      salidaDeBase,
      llegadaALugar,
      horaRecepcionLlamada,
      horaTerminoServicio
    } = formValues;
    const tiempoDeRespuesta = this.calcularDiferenciaHoras(salidaDeBase, llegadaALugar);
    const tiempoDeRespuestaLlamada = this.calcularDiferenciaHoras(horaRecepcionLlamada, llegadaALugar);
    const duracionServicio = this.calcularDiferenciaHoras(salidaDeBase, horaTerminoServicio);

    this.formRef.current.setFieldsValue({
      tiempoDeRespuesta,
      tiempoDeRespuestaLlamada,
      duracionServicio
    });
  };


  //Funcion para calcular la edad a partir de la fecha de nacimiento
  calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return "";

    const nacimiento = new Date(fechaNacimiento);
    const hoy = new Date();
    let edad = hoy.getFullYear() - nacimiento.getFullYear();
    const mes = hoy.getMonth() - nacimiento.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < nacimiento.getDate())) {
      edad--;
    }

    return edad;
  };

  //Función para calcular diferencia entre dos horas y devovlerlo en formato "HH:mm"
  calcularDiferenciaHoras = (inicio, fin) => {
    if (!inicio || !fin) return moment("00:00", "HH:mm");

    const inicioMoment = moment(inicio, "HH:mm");
    const finMoment = moment(fin, "HH:mm");
    const duracion = moment.duration(finMoment.diff(inicioMoment));
    if (duracion.asMinutes() < 0) return moment("00:00", "HH:mm");
    const horas = String(Math.floor(duracion.asHours())).padStart(2, "0");
    const minutos = String(duracion.minutes()).padStart(2, "0");

    return moment(`${horas}:${minutos}`, "HH:mm");
  }

  render() {
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Formulario de Servicio de Ambulancia"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div style={{ backgroundColor: "white", paddingLeft: 20, paddingRight: 20 }}>
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="llenarFormularioAmbulancia"
              layout
              bottom={
                <ButtonItem
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Guardar Formulario
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed}
            >

              <Tabs defaultActiveKey={1}>
                <TabPane tab="Datos Generales" tabKey={1} key={1} forceRender>
                  <Row>

                    <Col span={12}>
                      <FormItem
                        label="Folio Radio Cabina"
                        name="folioRadioCabina"
                        margin
                        numberCero
                        required
                        initialValue={0}
                      >
                        <InputNumberItem />
                      </FormItem>

                      <FormItem
                        label="Folio Parte de Servicio"
                        name="folioParteServicio"
                        margin
                        numberCero
                        required
                        initialValue={0}
                      >
                        <InputNumberItem />
                      </FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem
                        label="Fecha"
                        name="fechaservicio"
                        margin
                        required

                      >
                        <DatePickerItem></DatePickerItem>
                      </FormItem>


                      <FormItem
                        label="Hora de recepción de la llamada"
                        name="horaRecepcionLlamada"
                        margin
                        required
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                          onChange={() => this.actualizarCamposTiempo()}
                        />
                      </FormItem>

                    </Col>



                  </Row>
                  <Row>

                    <Col span={12}>
                      <FormItem
                        label="Soliciante del servicio"
                        margin
                        pattern
                        required
                        name="nombreSolicitante"


                      >
                        <InputItem placeholder="Nombre de la persona que solicito el servicio..."  ></InputItem>
                      </FormItem>

                      <FormItem
                        margin
                        label="Radio Operador"
                        pattern
                        name="radioOperadorId"

                        required
                      >
                        <SelectItem placeholder="Seleccionar radio operador...">
                          {this.state.operadores}
                        </SelectItem>
                      </FormItem>
                    </Col>


                    <Col span={12}>
                      <FormItem
                        margin
                        label="Terapia Intensiva"
                        pattern
                        required
                        name="terapiaIntensiva"

                      >
                        <SelectItem placeholder="Seleccionar...">
                          {opcionesTerapiaIntensiva.map((tipo) => (
                            <Option key={tipo} value={tipo}>
                              {tipo}
                            </Option>
                          ))}
                        </SelectItem>
                      </FormItem>

                      <FormItem
                        margin
                        label="Estudio"
                        pattern
                        required
                        name="estudioIdaVuelta"

                      >
                        <SelectItem placeholder="Seleccionar Ida/Vuelta...">
                          {opcionesEstudioIdaVuelta.map((opcion) => (
                            <Option key={opcion} value={opcion}>
                              {opcion}
                            </Option>
                          ))}
                        </SelectItem>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>

                <TabPane tab="Información del paciente" tabKey={2} key={2} forceRender>
                  <HeaderItem>Paciente</HeaderItem>
                  <BoxItem>

                    <Row>

                      <Col span={8}>
                        <FormItem
                          label="Paciente"
                          margin
                          pattern
                          required
                          name="paciente"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <InputItem placeholder="Nombre del paciente..."></InputItem>
                        </FormItem>

                        <FormItem
                          label="Género"
                          margin
                          pattern
                          name="genero"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}


                        >
                          <SelectItem
                            placeholder="Seleccione el sexo del paciente"
                          >
                            <Option value={1}>Masculino</Option>
                            <Option value={2}>Femenino</Option>
                            <Option value={3}>Otro</Option>
                          </SelectItem>
                        </FormItem>

                        <FormItem
                          label="Edad"
                          margin
                          pattern
                          name="edad"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}

                        >
                          <InputItem placeholder="Edad del paciente"></InputItem>
                        </FormItem>
                      </Col>

                      <Col span={12}>
                        <FormItem
                          label="Tipo de Dispositivo si ocupó oxígeno"
                          required
                          margin
                          pattern
                          name="tipoDisOxigeno"
                        >
                          <SelectItem placeholder="Seleccionar dispositivo...">
                            {opcionesTipoDisOxigeno.map((opcion) => (
                              <Option key={opcion} value={opcion}>
                                {opcion}
                              </Option>
                            ))}
                          </SelectItem>
                        </FormItem>

                        <FormItem
                          label="Médico Abordo"
                          margin
                          pattern
                          name="medicoAbordo"
                          tooltip="Nombre del médico abordo en caso de aplicar"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <InputItem placeholder="Nombre del médico abordo..."></InputItem>
                        </FormItem>
                      </Col>
                      <Col span={4}>
                        <FormItem
                          label="Lts X Min"
                          tooltip="Litros por minuto de oxígeno."
                          name="ltsXmin"
                          margin
                          numberCero
                          initialValue={0}
                        >
                          <InputNumberItem />
                        </FormItem>

                        <FormItem
                          label="¿Segundo piso?"
                          margin
                          pattern
                          name="segundooPiso"
                          labelCol={{ span: 18 }}
                          wrapperCol={{ span: 6 }}
                        >
                          <Checkbox></Checkbox>
                        </FormItem>
                      </Col>
                    </Row>
                  </BoxItem>
                  <HeaderItem>Contacto</HeaderItem>
                  <BoxItem>

                    <Row>
                      <Col span={12}>
                        <FormItem
                          label="Contacto"
                          margin
                          pattern
                          required
                          name="contacto"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <InputItem placeholder="Nombre del contacto..."></InputItem>
                        </FormItem>
                      </Col>
                      <Col span={12}>
                        <FormItem
                          label="Télefono del Contacto"
                          margin
                          pattern
                          required
                          name="telefonoContacto"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <InputItem placeholder="Télefono del contacto..."></InputItem>
                        </FormItem>
                      </Col>
                    </Row>
                  </BoxItem>

                </TabPane>
                <TabPane tab="Datos del servicio" tabKey={3} key={3} forceRender>
                  <HeaderItem>Datos de Ubicación</HeaderItem>
                  <BoxItem>
                    <Row>
                      <Col span={12}>
                        <FormItem
                          label="Mercado"
                          margin
                          pattern
                          required
                          name="mercado"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <SelectItem placeholder="Seleccionar el mercado...">
                            {opcionesMercado.map((opcion) => (
                              <Option key={opcion} value={opcion}>
                                {opcion}
                              </Option>
                            ))}
                          </SelectItem>
                        </FormItem>

                        <FormItem
                          label="Origen"
                          margin
                          pattern
                          required
                          name="origen"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <SelectItem placeholder="Seleccionar el origen...">
                            {opcionesOrigen.map((opcion) => (
                              <Option key={opcion} value={opcion}>
                                {opcion}
                              </Option>
                            ))}
                          </SelectItem>
                        </FormItem>

                        <FormItem
                          label="Base"
                          margin
                          pattern
                          required
                          name="baseOriente"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <SelectItem placeholder="Seleccionar base...">
                            {opcionesBaseOriente.map((opcion) => (
                              <Option key={opcion} value={opcion}>
                                {opcion}
                              </Option>
                            ))}
                          </SelectItem>
                        </FormItem>
                      </Col>

                      <Col span={12}>
                        <FormItem
                          label="Específicar origen"
                          margin
                          pattern
                          required
                          name="especificarOrigen"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <TextAreaItem placeholder="Específicar origen..." />
                        </FormItem>

                        <FormItem
                          label="Destino del paciente"
                          margin
                          pattern
                          required
                          name="destinoPaciente"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 17 }}
                        >
                          <TextAreaItem placeholder="Destino del paciente..." />
                        </FormItem>
                      </Col>
                    </Row>
                  </BoxItem>
                  <HeaderItem>Datos de la unidad</HeaderItem>
                  <BoxItem>
                    <Row>
                      <Col span={8}>
                        <FormItem
                          label="N° de Unidad"
                          margin
                          pattern
                          required
                          name="numeroUnidad"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 7 }}
                        >
                          <InputItem placeholder="N° de Unidad" />
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem
                          label="Operador"
                          margin
                          pattern
                          required
                          name="operadorID"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 14 }}
                        >
                          <SelectItem placeholder="Seleccionar Operador..." >
                            {this.state.operadores}
                          </SelectItem>
                        </FormItem>
                      </Col>
                      <Col span={8}>
                        <FormItem
                          label="TAMP"
                          margin
                          pattern
                          required
                          name="tampID"
                          labelCol={{ span: 7 }}
                          wrapperCol={{ span: 14 }}
                        >
                          <SelectItem placeholder="Seleccionar TAMP..." >
                            {this.state.operadores}
                          </SelectItem>
                        </FormItem>
                      </Col>
                    </Row>

                  </BoxItem>
                  <HeaderItem>Datos de pago</HeaderItem>
                  <BoxItem>

                    <Row>
                      <Col span={24}>
                        <FormItem
                          label="En caso de pagao en efectivo recibe"
                          margin
                          pattern
                          name="quienRecibioPagoId"
                          tooltip="Seleccione el operador que recibio el pago en efectivo"
                        >
                          <SelectItem placeholder="Seleccionar Operador..." >
                            {this.state.operadores}
                          </SelectItem>
                        </FormItem>
                      </Col>
                    </Row>
                  </BoxItem>
                </TabPane>
                <TabPane tab="Tiempos del servicio" tabKey={4} key={4} forceRender>
                  <Row>
                    <Col span={6}>
                      <FormItem
                        label="Envío de datos"
                        margin
                        pattern
                        required
                        name="envioDeDatos"
                        labelCol={{ span: 17 }}
                        wrapperCol={{ span: 7 }}
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                        //onChange={(time) => this.onTimeChange(time, "minutosSalida")}
                        />
                      </FormItem>

                      <FormItem
                        label="Salida de base"
                        margin
                        pattern
                        required
                        name="salidaDeBase"
                        labelCol={{ span: 17 }}
                        wrapperCol={{ span: 7 }}
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                          onChange={() => this.actualizarCamposTiempo()} />

                      </FormItem>

                      <FormItem
                        label="Hora de arribo"
                        margin
                        pattern
                        required
                        name="llegadaALugar"
                        labelCol={{ span: 17 }}
                        wrapperCol={{ span: 7 }}
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                          onChange={() => this.actualizarCamposTiempo()} />
                      </FormItem>
                    </Col>



                    <Col span={10}>
                      <FormItem
                        label="Hora de trayecto al hospital/domicilio"
                        margin
                        pattern
                        required
                        name="trayectoAlLugar"
                        labelCol={{ span: 17 }}
                        wrapperCol={{ span: 7 }}
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                        //onChange={(time) => this.onTimeChange(time, "minutosSalida")}
                        />
                      </FormItem>

                      <FormItem
                        label="Hora de Llegada al destino hospital o domicilio"
                        margin
                        pattern
                        required
                        name="llegadaADestino"
                        labelCol={{ span: 17 }}
                        wrapperCol={{ span: 7 }}
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                        //onChange={(time) => this.onTimeChange(time, "minutosSalida")}
                        />

                      </FormItem>

                      <FormItem
                        label="Hora de término de servicio"
                        margin
                        pattern
                        required
                        name="horaTerminoServicio"
                        labelCol={{ span: 17 }}
                        wrapperCol={{ span: 7 }}
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                          onChange={() => this.actualizarCamposTiempo()} />
                      </FormItem>
                    </Col>
                    <Col span={8}>
                      <FormItem
                        label="Tiempo de respuesta"
                        margin
                        pattern
                        name="tiempoDeRespuesta"
                        labelCol={{ span: 18 }}
                        wrapperCol={{ span: 6 }}
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                          //onChange={(time) => this.onTimeChange(time, "minutosSalida")}
                          disabled={true}
                        />
                      </FormItem>

                      <FormItem
                        label="Tiempo de respuesta entre llamada y arribo"
                        margin
                        pattern
                        name="tiempoDeRespuestaLlamada"
                        labelCol={{ span: 18 }}
                        wrapperCol={{ span: 6 }}
                        valuePropName="value"
                      >
                        <TimePicker
                          format="HH:mm"
                          disabled={true}
                        />
                      </FormItem>

                      <FormItem
                        label="Duración del servicio"
                        margin
                        pattern
                        name="duracionServicio"
                        labelCol={{ span: 18 }}
                        wrapperCol={{ span: 6 }}
                        valuePropName="value"

                      >
                        <TimePicker
                          //value={}
                          format="HH:mm"
                          disabled={true}

                        //onChange={(time) => this.onTimeChange(time, "minutosSalida")}
                        />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row>

                  </Row>
                </TabPane>
                <TabPane tab="Observaciones" tabKey={5} key={5} forceRender>
                  <Row>
                    <Col span={12}>
                      <FormItem
                        label="Comentarios"
                        margin
                        pattern
                        initialValue={""}
                        name="comentarios"
                        labelCol={{ span: 7 }}
                        wrapperCol={{ span: 17 }}
                      >
                        <TextAreaItem placeholder="Comentarios generales..." />
                      </FormItem>
                    </Col>
                    <Col span={6}>
                      <FormItem
                        label="Encuesta"
                        margin
                        pattern
                        name="encuesta"
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 6 }}
                        initialValue={false}
                      >
                        <Checkbox></Checkbox>
                      </FormItem>
                    </Col>
                  </Row>
                </TabPane>
              </Tabs>
            </Form>
          </Spin>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    usuarioId: state.user.usuarioId,

  };
};

export default connect(mapStateToProps)(LlenarFormulario);
